import { classNames } from "primereact/utils"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import MapFilters from "../filters/MapFilters"
import { mapFiltersConfig } from "./map.filters.config"
import RepairPlanRankingLegend from "./repairPlanRankingLegend/RepairPlanRankingLegend"
import RepairPlanLength from "./repairPlanLength/RepairPlanLength"
import { getItemWebStorage } from "src/features/webStorageSaver"

const REPAIR_PLAN_LENGTH_IROS_MIN_VERSION_BUILD = 6942;

export default function RepairPlanOverlay() {

    const filterMenuIsExpanded = useAppSelector(state => state.maps.repairPlan.filterMenuIsExpanded)
    const { mapRankingIsEnabled } = useAppSelector(state => state.contentHeader);

    const currentConfig = getItemWebStorage("currentConfig");
    const irosVersionBuild = currentConfig?.irosVersionBuild;
    const isRepairPlanLengthShown = irosVersionBuild >= REPAIR_PLAN_LENGTH_IROS_MIN_VERSION_BUILD;

    let mapOverlayClassName = classNames({
        "map-overlay": true,
        "with-filters": true,
        "filters-div-opened": filterMenuIsExpanded
    })

    return (
        <>
            <div className={mapOverlayClassName}>
                {isRepairPlanLengthShown && <RepairPlanLength />}
                {mapRankingIsEnabled && <RepairPlanRankingLegend />}
                <MapFilters filtersConfig={mapFiltersConfig} />
            </div>
        </>
    )
}
